import ReceiptService from "../ReceiptService";
import _ from 'lodash';
import {RECEIPTS_TABLE_NAME, SOURCE_RECEIPT_TABLE} from "../../constants";
import ReceiptSearch from "../ReceiptSearch.model";
import i18n from "../../../shared/i18n";
import {store} from "@/plugins/vuex";
import RelationsService from "@/modules/relations/RelationsService";

let getDefaultTableData = (differentFields = []) => {
  return {
    loading: false,
    rows: [],
    pagination: {
      limit: 50,
      page: 1,
      total: 0,
    },
    ordering: '-created_at',
    search: '',
    searchModel: new ReceiptSearch(),
    extraFilters: {},
    expand: 'total_items,recommended_by,recommended_by_user',
    toggleColumns: {
      fields: [...getDefaultTableFields(), ...differentFields],
      dynamicFields: [],
      requiredFields: ['receipt_no', 'customer', 'reserve'],
      defaultFields: ['receipt_no', 'customer', 'description', 'date', 'items', 'reserve'],
    }
  }
};

let getDefaultTableFields = () => {
  return [
    {
      key: 'receipt_no',
      label: i18n.t('Receipt'),
      sortable: true,
      tdClass: 'receipt_no_col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'customer',
      label: i18n.t('Customer'),
      sortable: true,
      tdClass: 'customer-col',
      isVisible: true,
      expand: 'customer'
    },
    {key: 'date', label: i18n.t('Date'), sortable: true, isVisible: true, tdClass: 'date_col', expand: ''},
    {
      key: 'description',
      label: i18n.t('Description'),
      sortable: true,
      tdClass: 'description-col',
      isVisible: true,
      expand: ''
    },
    {
      key: 'items',
      label: i18n.t('Total Items'),
      sortable: true,
      tdClass: 'items-col',
      isVisible: true,
      expand: 'total_items'
    },
    {
      key: 'reserve',
      label: i18n.t('Reserve'),
      sortable: true,
      tdClass: 'reserve-col',
      isVisible: true,
      expand: 'total_reserve'
    },
    {
      key: 'department',
      label: i18n.t('Department'),
      sortable: true,
      tdClass: 'department-col',
      isVisible: false,
      expand: 'department'
    },
    {
      key: 'item_location',
      label: i18n.t('Item Locations'),
      sortable: false,
      tdClass: 'item-location-col',
      isVisible: false,
      expand: 'item_locations'
    },
    {
      key: 'enable_multiple_locations',
      label: i18n.t('Multi Item-Location'),
      sortable: false,
      tdClass: 'item-location-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'commissions',
      label: i18n.t('Commissions'),
      sortable: false,
      tdClass: 'commissions-col',
      isVisible: false,
      expand: 'commissions',
      exclude_from_export: true
    },
    {key: 'minimum_commission', label: i18n.t('Min. Commissions'), sortable: true, isVisible: false, expand: ''},
    {
      key: 'insurance_rate',
      label: i18n.t('L/D Warranty'),
      sortable: true,
      tdClass: 'minimum-commission-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'lot_handling_charge',
      label: i18n.t('Entry Fee'),
      sortable: true,
      tdClass: 'insurance-rate-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'sold_items',
      label: i18n.t('Sold Items'),
      sortable: true,
      tdClass: 'lot-handling-charge-col',
      isVisible: false,
      expand: 'sold_items'
    },
    {
      key: 'unsold_items',
      label: i18n.t('Unsold Items'),
      sortable: true,
      tdClass: 'sold-items-col',
      isVisible: false,
      expand: 'unsold_items'
    },
    {
      key: 'created_data',
      label: i18n.t('Created at / Created by'),
      sortable: false,
      tdClass: 'created-data-col',
      isVisible: false,
      expand: 'created_by'
    },
    {
      key: 'updated_data',
      label: i18n.t('Updated at / Updated by'),
      sortable: false,
      tdClass: 'updated-data-col',
      isVisible: false,
      expand: 'updated_by'
    },
    {
      key: 'recommended_by_user',
      label: i18n.t('Recommended By User'),
      sortable: true,
      expand: 'recommended_by_user',
      isVisible: false,
    },
    {
      key: 'specialists',
      label: i18n.t('Specialists'),
      sortable: true,
      expand: 'specialists',
      isVisible: false,
    },
    {
      key: 'customer.accounting_code',
      label: i18n.t('Accounting Code'),
      sortable: false,
      tdClass: 'accounting_code-col',
      isVisible: false,
      expand: 'customer.accounting_code'
    },
    {
      key: 'receipt_contract_status',
      label: i18n.t('Consignment Status'),
      sortable: false,
      tdClass: 'receipt_contract_status-col',
      isVisible: false,
      expand: 'receipt_contract_status'
    },
    {
      key: 'pre_receipt_contract_status',
      label: i18n.t('Pre-Consignment Status'),
      sortable: false,
      tdClass: 'pre_receipt_contract_status-col',
      isVisible: false,
      expand: 'pre_receipt_contract_status'
    },
    {
      key: 'status',
      label: i18n.t('Status'),
      sortable: true,
      tdClass: 'status-col',
      isVisible: false,
      expand: '',
      exclude_from_export: true
    },
    {
      key: 'containers_count',
      label: i18n.t('Number of Containers'),
      sortable: true,
      tdClass: 'containers_count-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'container_type',
      label: i18n.t('Type of Container'),
      sortable: true,
      tdClass: 'container_type-col',
      isVisible: false,
      expand: ''
    },
    {
      key: 'rep_user',
      label: i18n.t('Representative User'),
      sortable: true,
      tdClass: 'rep_user-col',
      isVisible: false,
      expand: 'rep_user'
    },
    {
      key: 'dropper_uuid',
      label: i18n.t('Dropper'),
      sortable: true,
      tdClass: 'dropper-col',
      isVisible: false,
      expand: 'dropper'
    },
    {
      key: 'receipt_type',
      label: i18n.t('Receipt Type'),
      sortable: true,
      tdClass: 'receipt-type-col',
      isVisible: false,
      expand: ''
    },
    {
      key: "internal_images",
      label: i18n.t('Internal Images'),
      sortable: false,
      tdClass: 'internal-images-col',
      isVisible: false,
      expand: 'internal_images'
    },
    {
      key: "attachments",
      label: i18n.t('Attachments'),
      sortable: false,
      tdClass: 'attachments-col',
      isVisible: false,
      expand: 'attachments'
    },
  ]
}

export default {
  namespaced: true,
  state: {
    modal: {
      show: false,
      object: null,
      source: null
    },
    tableSource: null,
    tableData: {
      receipt: getDefaultTableData(),
      customer: getDefaultTableData(),
    },
    view: {
      loading: false,
      currentReceipt: null,
      termsData: {
        showCommissionsModal: false,
        loading: false,
        commissions: [],
        lot_handling_charge: null,
        insurance_rate: null,
        minimum_commission: null,
        rebate_rate: null,
      },
      dashboardData: {
        generalInfo: {
          data: {
            items: 0,
            reserved_items: 0,
            sold_items: 0,
            unsold_items: 0,
            high_estimate: 0,
            low_estimate: 0,
            reserve: 0,
          },
          loader: false
        },
        itemsByCategory: {
          data: [],
          loader: false
        },
        relations: {
          loader: false,
          notary: null,
          intermediary: null,
          contactPerson: null,
          personsOfInterest: []
        }
      },
      attachmentsCurrentTab: 0
    },
    receiptItemLocationModal: {
      show: false,
      itemLocations: []
    }
  },
  actions: {
    async getDashboardRelations({state}) {
      state.view.dashboardData.relations.loader = true
      let response = await RelationsService.getRelations({
        object_uuid: state.view.currentReceipt.uuid,
        expand: "related_customer"
      });
      state.view.dashboardData.relations.loader = false

      if (response.success) {
        state.view.dashboardData.relations.intermediary = response.body.results.find(r => r.type === 'intermediary') || null;
        state.view.dashboardData.relations.notary = response.body.results.find(r => r.type === 'notary') || null;
        state.view.dashboardData.relations.contactPerson = response.body.results.find(r => r.type === 'contact_person') || null;
        state.view.dashboardData.relations.personsOfInterest = response.body.results.filter(r => r.type === 'person_of_interest') || [];
      }

      return response;
    },
    async updateReceiptModalCustomer({state}, payload) {
      let obj = _.cloneDeep(state.modal.object);
      obj.customer_uuid = payload.uuid;
      obj.customer = payload;
      state.modal.object = obj;
    },
    async getModalObject({commit, state}, {uuid, source}) {
      let response = await ReceiptService.getReceipt(uuid, 'inventories,miscellaneous_items,specialists,rep_user,dropper,item_locations');
      if (response.success) {
        let r = response.body
        r.specialists_uuids = []
        if (r.specialists && r.specialists.length > 0) {
          r.specialists_uuids = r.specialists.map(s => s.uuid)
        }
        commit('updateModalObject', {object: _.cloneDeep(r), source})
      } else {
        state.modal.error = response.toastError;
      }
    },
    showModal({commit}, {object = {}, source} = {}) {
      commit('showModal', {object: _.cloneDeep(object), source});
    },
    hideModal({commit}) {
      commit('hideModal');
    },
    resetTableDataPaginationPage({state}) {
      state.tableData[state.tableSource].pagination.page = 1;
    },
    updateSearchModel({commit, state}, searchModel) {
      commit('updateSearchModel', new ReceiptSearch({
        ...state.tableData[state.tableSource].searchModel,
        ...searchModel
      }));
    },
    async resetTable({state, dispatch}) {
      const extraFilters = state.tableData[state.tableSource].extraFilters;
      const tmpToggleColumns = _.cloneDeep(state.tableData[state.tableSource].toggleColumns);
      let defaultTableData = getDefaultTableData();
      defaultTableData.pagination.limit = state.tableData[state.tableSource].pagination.limit;
      state.tableData[state.tableSource] = defaultTableData;
      state.tableData[state.tableSource].toggleColumns = tmpToggleColumns;
      state.tableData[state.tableSource].extraFilters = extraFilters;
      dispatch('getTableData');
    },
    async getTableData({commit, dispatch}, payload) {
      let params = await dispatch('getTableParams', payload);

      commit('updateTableLoading', true);
      const response = await ReceiptService.getReceipts(params);
      commit('updateTableLoading', false);

      if (response.success) {
        commit('updateTableData', {
          rows: response.body.results,
          pagination: {limit: params.limit, page: params.page, total: response.body.count},
          ordering: params.ordering,
          search: params.search
        });
      }

      return response;
    },
    async getTableParams({state}, payload = null) {
      let data;
      let currentTableData = state.tableData[state.tableSource];
      const ordering = await store.dispatch('global/getTableDataOrdering', {
        tableData: currentTableData,
        tableName: `${RECEIPTS_TABLE_NAME}.${state.tableSource}`
      })

      if (payload) {
        data = {
          ...payload.pagination,
          search: payload.search,
          ordering: payload.ordering,
        };
      } else {
        data = {
          ...currentTableData.pagination,
          search: currentTableData.search,
          ordering: ordering,
        }
      }

      if (currentTableData.searchModel) {
        const searchModelData = currentTableData.searchModel.toJSON();
        data = {
          ...data,
          ...searchModelData
        }
      }

      if (currentTableData.extraFilters) {
        data = {...data, ...currentTableData.extraFilters};
      }

      const defaultExpand = currentTableData.expand
      const expand = currentTableData.toggleColumns.fields
        .filter(c => currentTableData.toggleColumns.defaultFields.includes(c.key) && c.expand && !defaultExpand.includes(c.expand))
        .map(c => c.expand)
        .join(',')

      data.expand = `${expand},${defaultExpand}`;

      return data;
    },
    async updateTableSource({state}, {extraFilters, source}) {
      state.tableSource = source;
      state.tableData[source].extraFilters = extraFilters;
    },
    async updateReceipt({commit, state}, receipt) {
      let response = await ReceiptService.updateReceipt(
        receipt.uuid,
        receipt,
        'customer.billing_address,customer.shipping_address,recommended_by,recommended_by_user,branch,department,miscellaneous_items,specialists,rep_user,item_location,item_locations'
      );
      if (response.success && state.modal.source === SOURCE_RECEIPT_TABLE) {
        commit('updateReceipt', response.body);
      }
      return response;
    },
    async getReceipt({commit}, uuid) {
      commit('changeCurrentReceiptLoading');
      let expands = [
        'customer.shipping_address',
        'customer.accounting_code',
        'customer.logo',
        'recommended_by',
        'recommended_by_user',
        'specialists',
        'branch',
        'department',
        'miscellaneous_items.inventory',
        'customer.display_shipping_address',
        'commissions',
        'charges',
        'receipt_contract_status',
        'pre_receipt_contract_status',
        'rep_user',
        'item_location',
        'item_locations',
        'dropper',
      ].join(',')
      let {success, body} = await ReceiptService.getReceipt(uuid, expands);
      commit('changeCurrentReceiptLoading');
      if (success) {
        commit('updateViewReceipt', body);
      }
      return success;
    },
    async removeReceipt({dispatch}, receipt) {
      let response = await ReceiptService.removeReceipt(receipt.uuid);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async batchRemoveReceipts({dispatch}, payload) {
      let response = await ReceiptService.batchRemoveReceipts(payload);
      if (response.success) {
        dispatch('getTableData')
      }
      return response;
    },
    async updateViewReceipt({commit}, receipt) {
      commit('updateViewReceipt', receipt);
    },
    updateViewReceiptCustomer({commit}, customer) {
      commit('updateViewReceiptCustomer', customer);
    },
    async toggleCommissionsModal({commit}, payload) {
      commit('toggleCommissionsModal', payload);
    },
    async getTermsData({commit, state}) {
      commit('toggleTermsLoader', true);
      let response = await ReceiptService.getReceipt(state.view.currentReceipt.uuid, 'commissions');
      commit('toggleTermsLoader', false);

      if (response.success) {
        let {commissions, lot_handling_charge, insurance_rate, minimum_commission, rebate_rate} = response.body;
        await commit('updateTermsData', {commissions, lot_handling_charge, insurance_rate, minimum_commission, rebate_rate});
      }

      return response
    },
    async saveTermsPartialData({commit, state, dispatch}, payload) {
      let response = await ReceiptService.partialUpdateReceipt(state.view.currentReceipt.uuid, payload, 'commissions');
      let {commissions, lot_handling_charge, insurance_rate, minimum_commission, rebate_rate} = response.body;

      if (response.success) {
        dispatch('updateViewReceipt', response.body);
        commit('updateTermsData', {commissions, lot_handling_charge, insurance_rate, minimum_commission, rebate_rate});
      }

      return response;
    },

    async getDashboardData({dispatch}, payload) {
      dispatch('getDashboardGeneralInfo', payload);
      dispatch('getDashboardItemsByCategory', payload);
    },
    async getDashboardGeneralInfo({state}, payload) {
      state.view.dashboardData.generalInfo.loader = true;
      let response = await ReceiptService.getDashboardGeneralInfo(payload);
      if (response.success) {
        state.view.dashboardData.generalInfo.data = {
          ...state.view.dashboardData.generalInfo.data,
          ...response.body
        };
      }
      state.view.dashboardData.generalInfo.loader = false
    },
    async getDashboardItemsByCategory({state}, payload) {
      state.view.dashboardData.itemsByCategory.loader = true;
      state.view.dashboardData.itemsByCategory.data = await ReceiptService.getDashboardItemsByCategory(payload);
      state.view.dashboardData.itemsByCategory.loader = false
    },
    async updateToggleColumns({commit, dispatch}, payload) {
      if (payload.isSaveAction) {
        commit('updateTableLoading', true);
        await commit('updateToggleColumns', payload.selectedColumns);
        await dispatch('getTableData');
        commit('updateTableLoading', false);
      } else {
        await commit('updateToggleColumns', payload.selectedColumns);
      }
    },
    async showReceiptItemLocationModal({commit}, {itemLocations = null} = {}) {
      commit('showReceiptItemLocationModal', {itemLocations: _.cloneDeep(itemLocations)});
    },
    async hideReceiptItemLocationModal({commit}) {
      commit('hideReceiptItemLocationModal');
    },
    updateAttachmentsCurrentTab({state}, value) {
      state.view.attachmentsCurrentTab = value;
      return true
    }
  },
  mutations: {
    showModal: (state, {object, source}) => {
      state.modal.show = true;
      state.modal.object = object;
      state.modal.source = source;
    },
    updateModalObject: (state, {object, source}) => {
      state.modal.object = object;
      state.modal.source = source;
    },
    hideModal: state => state.modal.show = false,
    updateTableData: (state, payload) => state.tableData[state.tableSource] = {...state.tableData[state.tableSource], ...payload},
    updateTableLoading: (state, payload) => state.tableData[state.tableSource].loading = payload,
    updateReceipt: (state, receipt) => {
      const index = state.tableData[state.tableSource].rows.findIndex(r => r.uuid === receipt.uuid);
      state.tableData[state.tableSource].rows[index] = {...state.tableData[state.tableSource].rows[index], ...receipt};
      state.tableData[state.tableSource].rows = [...state.tableData[state.tableSource].rows];
    },
    changeCurrentReceiptLoading: state => state.view.loading = !state.view.loading,
    updateViewReceipt: (state, receipt) => {
      if (receipt) {
        state.view.currentReceipt = {
          ...state.view.currentReceipt,
          ...receipt
        }
      } else {
        state.view.currentReceipt = null
      }
    },
    updateViewReceiptCustomer: (state, customer) => state.view.currentReceipt.customer = {
      ...state.view.currentReceipt.customer,
      ...customer
    },
    toggleCommissionsModal: (state, data) => state.view.termsData.showCommissionsModal = data,
    toggleTermsLoader: (state, data) => state.view.termsData.loading = data,
    updateTermsData: (state, data) => {
      state.view.termsData = {...state.view.termsData, ...data};
    },
    updateSearchModel: (state, searchModel) => state.tableData[state.tableSource].searchModel = searchModel,
    updateToggleColumns: (state, selectedColumns) => {
      state.tableData[state.tableSource].toggleColumns.defaultFields = [...selectedColumns];
      let selectedFields = [];
      let notSelectedFields = [];
      selectedColumns.forEach(s => {
        selectedFields.push({
          ...state.tableData[state.tableSource].toggleColumns.fields.find(f => f.key === s),
          isVisible: true
        });
      });
      state.tableData[state.tableSource].toggleColumns.fields.forEach(f => {
        if (!selectedColumns.includes(f.key)) {
          notSelectedFields.push({...f, isVisible: false});
        }
      });
      state.tableData[state.tableSource].toggleColumns.fields = [...selectedFields, ...notSelectedFields];
    },
    showReceiptItemLocationModal: (state, {itemLocations}) => {
      state.receiptItemLocationModal.show = true
      state.receiptItemLocationModal.itemLocations = itemLocations
    },
    hideReceiptItemLocationModal: (state) => {
      state.receiptItemLocationModal.show = false
      state.receiptItemLocationModal.itemLocations = []
    },
  }
}
